/*
* @Author: Paul Gascou-Vaillancourt
* @Date:   2016-07-07 11:00:14
* @Last Modified by:   Paul
* @Last Modified time: 2016-07-11 14:40:15
*/

'use strict';

var settings = {};

settings.app = {
    debug: true
}

settings.logger = {
    url: '/log.php',
    method: 'POST',
    async: true
}


window.settings = settings;